import React, { FC, useEffect } from 'react'

import { GuestsCountPropsType } from '../../../../FilterBarTypes'

import './GuestCount.css'

export const GuestCount: FC<GuestsCountPropsType> = ({
  label,
  sortOrder,
  id,
  updateGuestsCount,
  count,
  minVal,
}) => {
  useEffect(() => {
    if (minVal && minVal > count) {
      updateGuestsCount(`guests-${id}`, minVal)
    }
  }, [])

  const handleDecrement = () => {
    if (count > minVal) {
      updateGuestsCount(`guests-${id}`, count - 1)
    }
  }

  const handleIncrement = () => {
    updateGuestsCount(`guests-${id}`, count + 1)
  }

  return (
    <div className="will-guests-filter-inner" style={{ order: `${sortOrder}` }}>
      <p className="will-guests-filter-label">{label}</p>

      <div className="will-guests-filter-counter">
        <button
          className="will-guests-filter-counter-button"
          onClick={handleDecrement}
          disabled={(minVal && count <= minVal) || !count}
          style={{
            cursor:
              (minVal && count <= minVal) || !count ? 'initial' : 'pointer',
            paddingBottom: '4px',
            opacity: (minVal && count <= minVal) || !count ? 0.4 : 1,
          }}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 10H16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <span className="will-guests-filter-count">{count}</span>
        <button
          className="will-guests-filter-counter-button"
          onClick={handleIncrement}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 4V16M4 10H16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}
